class PrazoCarregamento {
  constructor() {
    this.UM_DIA = 1;
    this.DOIS_DIA = 2;
    this.TRES_DIA = 3;
    this.QUATRO_DIA = 4;
    this.CINCO_DIA = 5;
  }

  getOptions() {
    return [
      {
        value: this.UM_DIA,
        name: 'Até o dia seguinte',
      },
      {
        value: this.DOIS_DIA,
        name: 'Até os próximos 2 dias',
      },
      {
        value: this.TRES_DIA,
        name: 'Até os próximos 3 dias',
      },
      {
        value: this.QUATRO_DIA,
        name: 'Até os próximos 4 dias',
      },
      {
        value: this.CINCO_DIA,
        name: 'Até os próximos 5 dias',
      },
    ];
  }

  getOption(value) {
    return this.getOptions()
      .filter(option => option.value === value)
      .shift();
  }

  getPrazoCarregamentoOption(value) {
    const result = this.getOption(value);
    return result || this.getOption(this.UM_DIA);
  }
}

export default new PrazoCarregamento();
